import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="rounded-xl border border-red-500/30 bg-red-500/10 p-4 text-sm text-red-400 flex items-center justify-between gap-3">
          <span>Erro ao carregar variantes.</span>
          <button
            onClick={() => this.setState({ error: null })}
            className="text-xs underline text-red-300 hover:text-white shrink-0"
          >
            Tentar novamente
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
